// Codigo do meio de pagamento na NF-e (tPag), gravado em forma_recebimento.codigo_pagamento_sefaz.
// E por ele — e nao pelo NOME da forma — que a tela decide a natureza do recebimento (§8.3).
export enum CodigoSefazEnum {
    Dinheiro = '01',
    Cheque = '02',
    CartaoCredito = '03',
    CartaoDebito = '04',
    Crediario = '05',
    Boleto = '15',
    Deposito = '16',
    Pix = '17',
    Outros = '99',
}
